import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, computed, action } from 'mobx';
import { computedFn } from 'mobx-utils';
import _get from 'lodash/get';
import _last from 'lodash/last';
import _head from 'lodash/head';
import _intersection from 'lodash/intersection';
import { mapInitialStateToStoreState, flow } from "../../utils/store.utils/index.js";
import { ACTION_TYPES, API_STATE, PAYMENT_METHODS } from "../../constants/index.js";
import { CartClient } from "../../clients/cart.client.js";
import { isValidProduct, isLoyaltyProduct, isWalletProduct, isQitafProduct, isMokafaaProduct, isCouponProduct, isRuleProduct, isCartType, getCartPredicate, isRuleLineItem, isLoyaltyLineItem, isActivityLineItem } from "../../utils/cart-product.utils/index.js";
import { makeLoyaltyProductFactory } from "../../factories/loyalty-product.factory.js";
import { makeLoyaltyProductFactoryV2 } from "../../factories/loyalty-product-v2.factory.js";
import { makeCouponProductFactory } from "../../factories/coupon-product.factory.js";
import { makeRuleProductFactory } from "../../factories/rule-product.factory.js";
import { makeRuleProductFactoryV2 } from "../../factories/rule-product-v2.factory.js";
import { cartContactFactory } from "../../factories/cart-contact.factory.js";
import { makeSkuProductFactory } from "../../factories/sku-product.factory.js";
var INITIAL = API_STATE.INITIAL,
  LOADING = API_STATE.LOADING,
  SUCCESS = API_STATE.SUCCESS,
  FAILED = API_STATE.FAILED;
var FETCH_CART = ACTION_TYPES.FETCH_CART,
  APPLY_COUPON = ACTION_TYPES.APPLY_COUPON,
  REMOVE_COUPON = ACTION_TYPES.REMOVE_COUPON,
  QITAF_REDEEM = ACTION_TYPES.QITAF_REDEEM,
  MOKAFAA_REDEEM = ACTION_TYPES.MOKAFAA_REDEEM,
  WALLET_REDEEM = ACTION_TYPES.WALLET_REDEEM;
var CHECKOUTCOM = PAYMENT_METHODS.CHECKOUTCOM,
  PAYFORT = PAYMENT_METHODS.PAYFORT,
  TAJAWAL_PAY = PAYMENT_METHODS.TAJAWAL_PAY,
  FORT = PAYMENT_METHODS.FORT;
var CartStore = (_dec = observable.shallow, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = action.bound, _dec7 = action.bound, _dec8 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  // eslint-disable-next-line default-param-last
  function CartStore(initialState, $env, makeProductFactory) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    if ($env === void 0) {
      $env = {};
    }
    if (makeProductFactory === void 0) {
      makeProductFactory = function makeProductFactory() {
        return null;
      };
    }
    this.$env = void 0;
    this.makeProductFactory = void 0;
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "API_STATE", _descriptor2, this);
    _initializerDefineProperty(this, "API_ERROR", _descriptor3, this);
    /**
     * is loading
     * @param {string} actionType
     * @return {boolean}
     */
    this.isLoading = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === LOADING;
    }, true);
    /**
     * is isFetched
     * @param {string} actionType
     * @return {boolean}
     */
    this.isFetched = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === SUCCESS;
    }, true);
    /**
     * hasError
     * @param {string} actionType
     * @return {boolean}
     */
    this.hasError = computedFn(function (actionType) {
      return _this.API_STATE[actionType] === FAILED;
    }, true);
    /**
     * get cart by cartId
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.cartId
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "getCart", _descriptor4, this);
    /**
     * apply coupon
     * @param {object} prop
     * @param {Object} prop.payload
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "applyCoupon", _descriptor5, this);
    /**
     * remove coupon
     * @param {object} prop
     * @param {Object} prop.payload
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "removeCoupon", _descriptor6, this);
    /**
     * redeem qitaf points
     * @param {object} prop
     * @param {Object} prop.payload
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "redeemQitaf", _descriptor7, this);
    /**
     * redeem MOKAFAA points
     * @param {object} prop
     * @param {Object} prop.payload
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "redeemMokafaa", _descriptor8, this);
    /**
     * redeem wallet
     * @param {object} prop
     * @param {Object} prop.payload
     * @param {Function} [prop.errorHandler]
     */
    _initializerDefineProperty(this, "redeemWallet", _descriptor9, this);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.makeProductFactory = makeProductFactory;
  }
  var _proto = CartStore.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  /**
   * sets API state to loading,
   * clears API error before fetching
   * @param {string} actionType
   */
  _proto.setAPILoading = function setAPILoading(actionType) {
    this.API_STATE[actionType] = LOADING;
    this.API_ERROR[actionType] = null;
  };
  /**
   * handle success
   * @param {Object} data
   * @param {string} actionType
   */
  _proto.onSuccess = function onSuccess(data, actionType) {
    this.API_STATE[actionType] = SUCCESS;
    this.data = data;
  }

  /**
   * handle error
   * @param {Object} error
   * @param {Function} errorHandler
   * @param {string} actionType
   */;
  _proto.onError = function onError(error, errorHandler, actionType) {
    var _error$response$data, _error$response;
    this.API_STATE[actionType] = FAILED;
    var errorResponse = (_error$response$data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : error.response;
    this.API_ERROR[actionType] = errorResponse;
    errorHandler(error);
  }

  /**
   * reset API state to default
   */;
  _proto.resetApiState = function resetApiState() {
    var _this$API_STATE, _this$API_ERROR;
    this.data = {};
    this.API_STATE = (_this$API_STATE = {}, _this$API_STATE[FETCH_CART] = INITIAL, _this$API_STATE[QITAF_REDEEM] = INITIAL, _this$API_STATE[WALLET_REDEEM] = INITIAL, _this$API_STATE[APPLY_COUPON] = INITIAL, _this$API_STATE[REMOVE_COUPON] = INITIAL, _this$API_STATE);
    this.API_ERROR = (_this$API_ERROR = {}, _this$API_ERROR[FETCH_CART] = null, _this$API_ERROR[QITAF_REDEEM] = null, _this$API_ERROR[WALLET_REDEEM] = null, _this$API_ERROR[APPLY_COUPON] = null, _this$API_ERROR[REMOVE_COUPON] = null, _this$API_ERROR);
  };
  _createClass(CartStore, [{
    key: "id",
    get:
    /**
     * cart id
     * @return {string}
     */
    function get() {
      var _this$data;
      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.cartId;
    }

    /**
     * createdAt
     * @return {Date}
     */
  }, {
    key: "createdAt",
    get: function get() {
      var _this$data2;
      return (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.createdAt;
    }

    /**
     * cart track id
     * @return {string}
     */
  }, {
    key: "trackId",
    get: function get() {
      var _this$data3;
      return (_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : _this$data3.trackId;
    }

    /**
     * checks if a cart exists in the store
     * @return {string}
     */
  }, {
    key: "hasCart",
    get: function get() {
      return Boolean(this.id);
    }

    /**
     * checks whether cart has been checked out or not
     * @return {string}
     */
  }, {
    key: "hasBeenCheckedOut",
    get: function get() {
      var _this$data4;
      return (_this$data4 = this.data) === null || _this$data4 === void 0 ? void 0 : _this$data4.orderNumber;
    }
  }, {
    key: "productSkus",
    get: function get() {
      var _this$$env$currency, _this$product, _this$data5, _this$data5$displayIt, _this$data5$displayIt2, _this$data5$displayIt3, _this$data5$displayIt4;
      var skuFactory = makeSkuProductFactory((_this$$env$currency = this.$env.currency) === null || _this$$env$currency === void 0 ? void 0 : _this$$env$currency.convertAndFormatPrice, (_this$product = this.product) === null || _this$product === void 0 ? void 0 : _this$product.skusPrices);
      return (_this$data5 = this.data) === null || _this$data5 === void 0 ? void 0 : (_this$data5$displayIt = _this$data5.displayItems) === null || _this$data5$displayIt === void 0 ? void 0 : (_this$data5$displayIt2 = _this$data5$displayIt.lineItems) === null || _this$data5$displayIt2 === void 0 ? void 0 : (_this$data5$displayIt3 = _this$data5$displayIt2.find(isActivityLineItem)) === null || _this$data5$displayIt3 === void 0 ? void 0 : (_this$data5$displayIt4 = _this$data5$displayIt3.breakdown) === null || _this$data5$displayIt4 === void 0 ? void 0 : _this$data5$displayIt4.map(skuFactory);
    }

    /**
     * total to be paid price
     * @return {number}
     */
  }, {
    key: "totalToBePaid",
    get: function get() {
      var _this$data6, _this$data6$displayIt, _this$data6$displayIt2;
      return (_this$data6 = this.data) === null || _this$data6 === void 0 ? void 0 : (_this$data6$displayIt = _this$data6.displayItems) === null || _this$data6$displayIt === void 0 ? void 0 : (_this$data6$displayIt2 = _this$data6$displayIt.total) === null || _this$data6$displayIt2 === void 0 ? void 0 : _this$data6$displayIt2.totalToBePaid;
    }

    /**
     * displayed total price
     * @return {number}
     */
  }, {
    key: "displayedTotalToBePaid",
    get: function get() {
      var _this$$env$currency2;
      return (_this$$env$currency2 = this.$env.currency) === null || _this$$env$currency2 === void 0 ? void 0 : _this$$env$currency2.convertAndFormatPrice(this.totalToBePaid);
    }

    /**
     * total price
     * @return {number}
     */
  }, {
    key: "total",
    get: function get() {
      var _this$data7, _this$data7$displayIt, _this$data7$displayIt2;
      return (_this$data7 = this.data) === null || _this$data7 === void 0 ? void 0 : (_this$data7$displayIt = _this$data7.displayItems) === null || _this$data7$displayIt === void 0 ? void 0 : (_this$data7$displayIt2 = _this$data7$displayIt.total) === null || _this$data7$displayIt2 === void 0 ? void 0 : _this$data7$displayIt2.total;
    }

    /**
     * total price (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedTotal",
    get: function get() {
      var _this$$env$currency3;
      return (_this$$env$currency3 = this.$env.currency) === null || _this$$env$currency3 === void 0 ? void 0 : _this$$env$currency3.convertAndFormatPrice(this.total);
    }

    /**
     * cart has total price > 0
     * @return {boolean}
     */
  }, {
    key: "cartHasTotal",
    get: function get() {
      return this.total > 0;
    }

    /**
     * net total price (total without vat)
     * @return {number}
     */
  }, {
    key: "totalWithoutVat",
    get: function get() {
      return this.total - this.vat;
    }

    /**
     * net total price (total without vat) (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedTotalWithoutVat",
    get: function get() {
      var _this$$env$currency4;
      return (_this$$env$currency4 = this.$env.currency) === null || _this$$env$currency4 === void 0 ? void 0 : _this$$env$currency4.convertAndFormatPrice(this.totalWithoutVat);
    }

    /**
     * total price currency
     * @return {string}
     */
  }, {
    key: "totalCurrency",
    get: function get() {
      var _this$data8, _this$data8$displayIt, _this$data8$displayIt2;
      return (_this$data8 = this.data) === null || _this$data8 === void 0 ? void 0 : (_this$data8$displayIt = _this$data8.displayItems) === null || _this$data8$displayIt === void 0 ? void 0 : (_this$data8$displayIt2 = _this$data8$displayIt.total) === null || _this$data8$displayIt2 === void 0 ? void 0 : _this$data8$displayIt2.currency;
    }

    /**
     * subtotal After Discount
     * @return {number}
     */
  }, {
    key: "subtotalAfterDiscount",
    get: function get() {
      var _this$data$displayTot, _this$data9, _this$data9$displayTo;
      return (_this$data$displayTot = (_this$data9 = this.data) === null || _this$data9 === void 0 ? void 0 : (_this$data9$displayTo = _this$data9.displayTotals) === null || _this$data9$displayTo === void 0 ? void 0 : _this$data9$displayTo.subTotalAfterDiscount) !== null && _this$data$displayTot !== void 0 ? _this$data$displayTot : 0;
    }

    /**
     * displayed subtotal After Discount
     * @return {number}
     */
  }, {
    key: "displayedSubtotalAfterDiscount",
    get: function get() {
      var _this$$env$currency5;
      return (_this$$env$currency5 = this.$env.currency) === null || _this$$env$currency5 === void 0 ? void 0 : _this$$env$currency5.convertAndFormatPrice(this.subtotalAfterDiscount);
    }

    /**
     * subtotal price
     * @return {number}
     */
  }, {
    key: "subtotal",
    get: function get() {
      var _this$data$displayIte, _this$data10, _this$data10$displayI;
      // return this.data?.totals.subtotal ?? 0;
      return (_this$data$displayIte = (_this$data10 = this.data) === null || _this$data10 === void 0 ? void 0 : (_this$data10$displayI = _this$data10.displayItems) === null || _this$data10$displayI === void 0 ? void 0 : _this$data10$displayI.total.subTotal) !== null && _this$data$displayIte !== void 0 ? _this$data$displayIte : 0;
    }

    /**
     * subtotal price
     * @return {number}
     */
  }, {
    key: "subtotalWithVat",
    get: function get() {
      var _this$data$displayIte2, _this$data$displayIte3, _head2;
      var productItem = (_this$data$displayIte2 = this.data.displayItems) === null || _this$data$displayIte2 === void 0 ? void 0 : (_this$data$displayIte3 = _this$data$displayIte2.lineItems) === null || _this$data$displayIte3 === void 0 ? void 0 : _this$data$displayIte3.filter(function (product) {
        return !!getCartPredicate(product.type);
      });
      return (_head2 = _head(productItem)) === null || _head2 === void 0 ? void 0 : _head2.price.totalWithVat;
    }

    /**
     * subtotal price (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedSubtotal",
    get: function get() {
      var _this$$env$currency6;
      return (_this$$env$currency6 = this.$env.currency) === null || _this$$env$currency6 === void 0 ? void 0 : _this$$env$currency6.convertAndFormatPrice(this.subtotal);
    }

    /**
     * value added tax
     * @return {number}
     */
  }, {
    key: "vat",
    get: function get() {
      var _this$data11, _this$data11$displayI, _this$data11$displayI2;
      // return this.data?.totals?.outputVatMeta;
      return (_this$data11 = this.data) === null || _this$data11 === void 0 ? void 0 : (_this$data11$displayI = _this$data11.displayItems) === null || _this$data11$displayI === void 0 ? void 0 : (_this$data11$displayI2 = _this$data11$displayI.total) === null || _this$data11$displayI2 === void 0 ? void 0 : _this$data11$displayI2.vat;
    }
  }, {
    key: "includeTotalWithVat",
    get: function get() {
      var _this$data12, _this$data12$displayI;
      return (_this$data12 = this.data) === null || _this$data12 === void 0 ? void 0 : (_this$data12$displayI = _this$data12.displayItems) === null || _this$data12$displayI === void 0 ? void 0 : _this$data12$displayI.includeTotalWithVat;
    }

    /**
     * has vat
     * @return {number}
     */
  }, {
    key: "hasVat",
    get: function get() {
      return this.vat > 0;
    }

    /**
     * value added tax (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedVat",
    get: function get() {
      var _this$$env$currency7;
      return (_this$$env$currency7 = this.$env.currency) === null || _this$$env$currency7 === void 0 ? void 0 : _this$$env$currency7.convertAndFormatPrice(this.vat);
    }

    /**
     * products
     * @return {Array<CartProduct>}
     */
  }, {
    key: "products",
    get: function get() {
      var _this$data$products, _this$data13;
      return (_this$data$products = (_this$data13 = this.data) === null || _this$data13 === void 0 ? void 0 : _this$data13.products) !== null && _this$data$products !== void 0 ? _this$data$products : [];
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "validProducts",
    get: function get() {
      var _this$products$filter, _this$products;
      return (_this$products$filter = (_this$products = this.products) === null || _this$products === void 0 ? void 0 : _this$products.filter(isValidProduct)) !== null && _this$products$filter !== void 0 ? _this$products$filter : [];
    }

    /**
     * product type { HOTEL, FLIGHT, ACCOMMODATION, ACTIVITIES }
     * @return {string}
     */
  }, {
    key: "type",
    get: function get() {
      var _head3, _this$products2;
      return (_head3 = _head((_this$products2 = this.products) === null || _this$products2 === void 0 ? void 0 : _this$products2.filter(isCartType))) === null || _head3 === void 0 ? void 0 : _head3.type;
    }

    /**
     * raw product
     * @return {Object}
     */
  }, {
    key: "rawProduct",
    get: function get() {
      var _this$validProducts;
      return _last((_this$validProducts = this.validProducts) === null || _this$validProducts === void 0 ? void 0 : _this$validProducts.filter(getCartPredicate(this.type))) || {};
    }

    /**
     * product
     * @return {Object}
     */
  }, {
    key: "product",
    get: function get() {
      return this.makeProductFactory(this.rawProduct);
    }

    /**
     * timezone header
     * @return {string}
     */
  }, {
    key: "timezoneHeader",
    get: function get() {
      var _this$data14, _this$data14$addition;
      return ((_this$data14 = this.data) === null || _this$data14 === void 0 ? void 0 : (_this$data14$addition = _this$data14.additionalData) === null || _this$data14$addition === void 0 ? void 0 : _this$data14$addition.headers['x-tz']) || 'UTC';
    }

    /**
     * allowed payment methods
     * @return {string}
     */
  }, {
    key: "allowedPaymentMethods",
    get: function get() {
      var _this$data15, _this$data15$allowedP;
      return (_this$data15 = this.data) === null || _this$data15 === void 0 ? void 0 : (_this$data15$allowedP = _this$data15.allowedPaymentMethods) === null || _this$data15$allowedP === void 0 ? void 0 : _this$data15$allowedP.map(function (m) {
        return m === null || m === void 0 ? void 0 : m.provider;
      });
    }

    /**
     * returns merchant id for apple pay header
     * @returns {String}
     */
  }, {
    key: "appleMIdHeader",
    get: function get() {
      var _this$data16, _this$data16$allowedP, _this$data16$allowedP2;
      return (_this$data16 = this.data) === null || _this$data16 === void 0 ? void 0 : (_this$data16$allowedP = _this$data16.allowedPaymentMethods) === null || _this$data16$allowedP === void 0 ? void 0 : (_this$data16$allowedP2 = _this$data16$allowedP.find(function (x) {
        return x === null || x === void 0 ? void 0 : x.applemid;
      })) === null || _this$data16$allowedP2 === void 0 ? void 0 : _this$data16$allowedP2.applemid;
    }

    /**
     * check if cart is created from meta
     * @return {string}
     */
  }, {
    key: "isMetaCart",
    get: function get() {
      return _get(this.data, 'additionalData.channelData.utm_medium', '') === 'meta' || _get(this.data, 'additionalData.metaHeaders.x-utm-medium', '') === 'meta';
    }

    /**
     * check if cart has employee discount
     * @return {boolean}
     */
  }, {
    key: "isEmployeeDiscount",
    get: function get() {
      return _get(this.data, 'additionalData.metaHeaders.x-user-account-role', '');
    }

    /**
     * allowed payment methods
     * @return {string}
     */
  }, {
    key: "paymentCardOption",
    get: function get() {
      var cardMethods = [CHECKOUTCOM, PAYFORT, TAJAWAL_PAY, FORT];
      var allowedCardMethods = _intersection(this.allowedPaymentMethods, cardMethods);
      return _head(allowedCardMethods);
    }

    /**
     * loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "loyalties",
    get: function get() {
      var _this$$env$currency8, _this$$env$currency$c, _this$$env$currency9, _this$products3, _this$products3$filte;
      var loyaltyFactory = makeLoyaltyProductFactory((_this$$env$currency8 = this.$env.currency) === null || _this$$env$currency8 === void 0 ? void 0 : _this$$env$currency8.convertAndFormatPrice, (_this$$env$currency$c = (_this$$env$currency9 = this.$env.currency) === null || _this$$env$currency9 === void 0 ? void 0 : _this$$env$currency9.currentCurrency) !== null && _this$$env$currency$c !== void 0 ? _this$$env$currency$c : '');
      return (_this$products3 = this.products) === null || _this$products3 === void 0 ? void 0 : (_this$products3$filte = _this$products3.filter(isLoyaltyProduct)) === null || _this$products3$filte === void 0 ? void 0 : _this$products3$filte.map(loyaltyFactory);
    }

    /**
     * valid loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "validLoyalties",
    get: function get() {
      var _this$$env$currency10, _this$$env$currency$c2, _this$$env$currency11, _this$data17, _this$data17$displayI, _this$data17$displayI2, _this$data17$displayI3;
      var loyaltyFactory = makeLoyaltyProductFactoryV2((_this$$env$currency10 = this.$env.currency) === null || _this$$env$currency10 === void 0 ? void 0 : _this$$env$currency10.convertAndFormatPrice, (_this$$env$currency$c2 = (_this$$env$currency11 = this.$env.currency) === null || _this$$env$currency11 === void 0 ? void 0 : _this$$env$currency11.currentCurrency) !== null && _this$$env$currency$c2 !== void 0 ? _this$$env$currency$c2 : '');
      return (_this$data17 = this.data) === null || _this$data17 === void 0 ? void 0 : (_this$data17$displayI = _this$data17.displayItems) === null || _this$data17$displayI === void 0 ? void 0 : (_this$data17$displayI2 = _this$data17$displayI.lineItems) === null || _this$data17$displayI2 === void 0 ? void 0 : (_this$data17$displayI3 = _this$data17$displayI2.filter(isLoyaltyLineItem)) === null || _this$data17$displayI3 === void 0 ? void 0 : _this$data17$displayI3.map(loyaltyFactory);
    }

    /**
     * valid loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "validLoyalty",
    get: function get() {
      return this.validLoyalties && this.validLoyalties[0];
    }

    /**
     * qitaf redeem products
     * @return {Array<Object>}
     */
  }, {
    key: "qitafProduct",
    get: function get() {
      var _this$$env$currency12, _this$$env$currency$c3, _this$$env$currency13, _this$validProducts2, _this$validProducts2$;
      var loyaltyFactory = makeLoyaltyProductFactory((_this$$env$currency12 = this.$env.currency) === null || _this$$env$currency12 === void 0 ? void 0 : _this$$env$currency12.convertAndFormatPrice, (_this$$env$currency$c3 = (_this$$env$currency13 = this.$env.currency) === null || _this$$env$currency13 === void 0 ? void 0 : _this$$env$currency13.currentCurrency) !== null && _this$$env$currency$c3 !== void 0 ? _this$$env$currency$c3 : '');
      return _head((_this$validProducts2 = this.validProducts) === null || _this$validProducts2 === void 0 ? void 0 : (_this$validProducts2$ = _this$validProducts2.filter(isQitafProduct)) === null || _this$validProducts2$ === void 0 ? void 0 : _this$validProducts2$.map(loyaltyFactory));
    }

    /**
     * has qitaf redeem product
     * @return {Boolean}
     */
  }, {
    key: "redeemedWithQitaf",
    get: function get() {
      var _this$validProducts3;
      return (_this$validProducts3 = this.validProducts) === null || _this$validProducts3 === void 0 ? void 0 : _this$validProducts3.some(isQitafProduct);
    }

    /**
     * has mokafaa redeem product
     * @return {Boolean}
     */
  }, {
    key: "redeemedWithMokafaa",
    get: function get() {
      var _this$validProducts4;
      return (_this$validProducts4 = this.validProducts) === null || _this$validProducts4 === void 0 ? void 0 : _this$validProducts4.some(isMokafaaProduct);
    }

    /**
     * wallet redeem product
     * @return {Array<Object>}
     */
  }, {
    key: "walletProduct",
    get: function get() {
      var _this$$env$currency14, _this$$env$currency$c4, _this$$env$currency15, _this$validProducts5, _this$validProducts5$;
      var loyaltyFactory = makeLoyaltyProductFactory((_this$$env$currency14 = this.$env.currency) === null || _this$$env$currency14 === void 0 ? void 0 : _this$$env$currency14.convertAndFormatPrice, (_this$$env$currency$c4 = (_this$$env$currency15 = this.$env.currency) === null || _this$$env$currency15 === void 0 ? void 0 : _this$$env$currency15.currentCurrency) !== null && _this$$env$currency$c4 !== void 0 ? _this$$env$currency$c4 : '');
      return _head((_this$validProducts5 = this.validProducts) === null || _this$validProducts5 === void 0 ? void 0 : (_this$validProducts5$ = _this$validProducts5.filter(isWalletProduct)) === null || _this$validProducts5$ === void 0 ? void 0 : _this$validProducts5$.map(loyaltyFactory));
    }

    /**
     * has wallet redeem product
     * @return {Boolean}
     */
  }, {
    key: "redeemedWithWallet",
    get: function get() {
      var _this$validProducts6;
      return (_this$validProducts6 = this.validProducts) === null || _this$validProducts6 === void 0 ? void 0 : _this$validProducts6.some(isWalletProduct);
    }

    /**
     * checks if the user has performed full wallet redeem or not
     * @returns {Boolean}
     */
  }, {
    key: "fullyRedeemedWithWallet",
    get: function get() {
      return this.redeemedWithWallet && !this.cartHasTotal;
    }

    /**
     * coupon products
     * @return {Array<Object>}
     */
  }, {
    key: "coupons",
    get: function get() {
      var _this$$env$currency16, _this$products4, _this$products4$filte;
      var couponFactory = makeCouponProductFactory((_this$$env$currency16 = this.$env.currency) === null || _this$$env$currency16 === void 0 ? void 0 : _this$$env$currency16.convertAndFormatPrice);
      return (_this$products4 = this.products) === null || _this$products4 === void 0 ? void 0 : (_this$products4$filte = _this$products4.filter(isCouponProduct)) === null || _this$products4$filte === void 0 ? void 0 : _this$products4$filte.map(couponFactory);
    }

    /**
     * valid coupon products
     * @return {Array<Object>}
     */
  }, {
    key: "validCoupons",
    get: function get() {
      var _this$$env$currency17, _this$validProducts7, _this$validProducts7$;
      var couponFactory = makeCouponProductFactory((_this$$env$currency17 = this.$env.currency) === null || _this$$env$currency17 === void 0 ? void 0 : _this$$env$currency17.convertAndFormatPrice);
      return (_this$validProducts7 = this.validProducts) === null || _this$validProducts7 === void 0 ? void 0 : (_this$validProducts7$ = _this$validProducts7.filter(isCouponProduct)) === null || _this$validProducts7$ === void 0 ? void 0 : _this$validProducts7$.map(couponFactory);
    }

    /**
     * coupon product
     * @return {Object}
     */
  }, {
    key: "coupon",
    get: function get() {
      return _head(this.coupons);
    }

    /**
     * has an applied coupon
     * @return {Boolean}
     */
  }, {
    key: "appliedCoupon",
    get: function get() {
      var _this$coupons;
      return ((_this$coupons = this.coupons) === null || _this$coupons === void 0 ? void 0 : _this$coupons.length) > 0;
    }

    /**
     * has an applied valid coupon
     * @return {Boolean}
     */
  }, {
    key: "appliedValidCoupon",
    get: function get() {
      var _this$validCoupons;
      return ((_this$validCoupons = this.validCoupons) === null || _this$validCoupons === void 0 ? void 0 : _this$validCoupons.length) > 0;
    }

    /**
     * rule products
     * @return {Array<Object>}
     */
  }, {
    key: "rules",
    get: function get() {
      var _this$$env$currency18, _this$products5, _this$products5$filte;
      var ruleFactory = makeRuleProductFactory((_this$$env$currency18 = this.$env.currency) === null || _this$$env$currency18 === void 0 ? void 0 : _this$$env$currency18.convertAndFormatPrice);
      return (_this$products5 = this.products) === null || _this$products5 === void 0 ? void 0 : (_this$products5$filte = _this$products5.filter(isRuleProduct)) === null || _this$products5$filte === void 0 ? void 0 : _this$products5$filte.map(ruleFactory);
    }

    /**
     * is negative rule
     * @returns {boolean}
     */
  }, {
    key: "isNegativeRule",
    get: function get() {
      var _this$rules, _this$rules$filter;
      return ((_this$rules = this.rules) === null || _this$rules === void 0 ? void 0 : (_this$rules$filter = _this$rules.filter(function (e) {
        return (Math === null || Math === void 0 ? void 0 : Math.sign(e === null || e === void 0 ? void 0 : e.totalPrice)) === -1;
      })) === null || _this$rules$filter === void 0 ? void 0 : _this$rules$filter.length) > 0;
    }

    /**
     * valid rule products
     * @return {Array<Object>}
     */
  }, {
    key: "validRules",
    get: function get() {
      var _this$$env$currency19, _this$$env$currency$c5, _this$$env$currency20, _this$data18, _this$data19, _this$data19$displayI, _this$data19$displayI2, _this$data19$displayI3;
      var ruleFactory = makeRuleProductFactoryV2((_this$$env$currency19 = this.$env.currency) === null || _this$$env$currency19 === void 0 ? void 0 : _this$$env$currency19.convertAndFormatPrice, (_this$$env$currency$c5 = (_this$$env$currency20 = this.$env.currency) === null || _this$$env$currency20 === void 0 ? void 0 : _this$$env$currency20.currentCurrency) !== null && _this$$env$currency$c5 !== void 0 ? _this$$env$currency$c5 : '', (_this$data18 = this.data) === null || _this$data18 === void 0 ? void 0 : _this$data18.coupon);
      return (_this$data19 = this.data) === null || _this$data19 === void 0 ? void 0 : (_this$data19$displayI = _this$data19.displayItems) === null || _this$data19$displayI === void 0 ? void 0 : (_this$data19$displayI2 = _this$data19$displayI.lineItems) === null || _this$data19$displayI2 === void 0 ? void 0 : (_this$data19$displayI3 = _this$data19$displayI2.filter(isRuleLineItem)) === null || _this$data19$displayI3 === void 0 ? void 0 : _this$data19$displayI3.map(ruleFactory);
    }

    /**
     * valid rule products
     * this is old version which is copied from payment sdk
     * to avoid unexpected behavior
     * @return {Array<Object>}
     */
  }, {
    key: "validRulesV2",
    get: function get() {
      var ruleFactory = makeRuleProductFactory(this.$env.currency.convertAndFormatPrice);
      return this.validProducts.filter(isRuleProduct).map(ruleFactory);
    }

    /**
     * contact
     * @return {Object}
     */
  }, {
    key: "contact",
    get: function get() {
      var _this$$env$config;
      return cartContactFactory(_get(this.data, 'contact'), (_this$$env$config = this.$env.config) === null || _this$$env$config === void 0 ? void 0 : _this$$env$config.dialCode);
    }
  }]);
  return CartStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "API_STATE", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref;
    return _ref = {}, _ref[FETCH_CART] = INITIAL, _ref[QITAF_REDEEM] = INITIAL, _ref[WALLET_REDEEM] = INITIAL, _ref[APPLY_COUPON] = INITIAL, _ref[REMOVE_COUPON] = INITIAL, _ref[MOKAFAA_REDEEM] = INITIAL, _ref;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "API_ERROR", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref2;
    return _ref2 = {}, _ref2[FETCH_CART] = null, _ref2[QITAF_REDEEM] = null, _ref2[WALLET_REDEEM] = null, _ref2[APPLY_COUPON] = null, _ref2[REMOVE_COUPON] = null, _ref2[MOKAFAA_REDEEM] = null, _ref2;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "id", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createdAt", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "trackId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasBeenCheckedOut", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasBeenCheckedOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productSkus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productSkus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalToBePaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalToBePaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedTotalToBePaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotalToBePaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "total", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "total"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartHasTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartHasTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalWithoutVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalWithoutVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedTotalWithoutVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotalWithoutVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalCurrency", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalCurrency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subtotalAfterDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalAfterDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedSubtotalAfterDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedSubtotalAfterDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subtotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subtotalWithVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalWithVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedSubtotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedSubtotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "includeTotalWithVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "includeTotalWithVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedVat", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedVat"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "products", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "products"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validProducts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "type", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "type"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rawProduct", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rawProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "product", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timezoneHeader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timezoneHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowedPaymentMethods", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowedPaymentMethods"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appleMIdHeader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appleMIdHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMetaCart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMetaCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmployeeDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmployeeDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentCardOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCardOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loyalties", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loyalties"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validLoyalties", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validLoyalties"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validLoyalty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validLoyalty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "qitafProduct", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "qitafProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redeemedWithQitaf", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeemedWithQitaf"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redeemedWithMokafaa", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeemedWithMokafaa"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "walletProduct", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "walletProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redeemedWithWallet", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeemedWithWallet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullyRedeemedWithWallet", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fullyRedeemedWithWallet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "coupons", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "coupons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validCoupons", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validCoupons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "coupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "coupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appliedCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appliedValidCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedValidCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rules", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rules"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNegativeRule", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNegativeRule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validRules", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validRules"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validRulesV2", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validRulesV2"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contact", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAPILoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAPILoading"), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getCart", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function getCart(_ref3) {
      var _this2 = this;
      var payload = _ref3.payload,
        _ref3$errorHandler = _ref3.errorHandler,
        errorHandler = _ref3$errorHandler === void 0 ? function () {
          return null;
        } : _ref3$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this2.hasCart || payload.cartId !== _this2.id)) {
                _context.next = 12;
                break;
              }
              _this2.setAPILoading(FETCH_CART);
              _context.prev = 2;
              _context.next = 5;
              return CartClient.getCart(payload);
            case 5:
              response = _context.sent;
              _this2.onSuccess(response, FETCH_CART);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              _this2.onError(_context.t0, errorHandler, FETCH_CART);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 9]]);
      })();
    });
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "applyCoupon", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function applyCoupon(_ref4) {
      var _this3 = this;
      var payload = _ref4.payload,
        _ref4$errorHandler = _ref4.errorHandler,
        errorHandler = _ref4$errorHandler === void 0 ? function () {
          return null;
        } : _ref4$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.setAPILoading(APPLY_COUPON);
              _context2.prev = 1;
              _context2.next = 4;
              return CartClient.applyCoupon(payload);
            case 4:
              response = _context2.sent;
              _this3.onSuccess(response, APPLY_COUPON);
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              _this3.onError(_context2.t0, errorHandler, APPLY_COUPON);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "removeCoupon", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function removeCoupon(_ref5) {
      var _this4 = this;
      var payload = _ref5.payload,
        _ref5$errorHandler = _ref5.errorHandler,
        errorHandler = _ref5$errorHandler === void 0 ? function () {
          return null;
        } : _ref5$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.setAPILoading(REMOVE_COUPON);
              _context3.prev = 1;
              _context3.next = 4;
              return CartClient.removeCoupon(payload);
            case 4:
              response = _context3.sent;
              _this4.onSuccess(response, REMOVE_COUPON);
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              _this4.onError(_context3.t0, errorHandler, REMOVE_COUPON);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "redeemQitaf", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function redeemQitaf(_ref6) {
      var _this5 = this;
      var payload = _ref6.payload,
        _ref6$errorHandler = _ref6.errorHandler,
        errorHandler = _ref6$errorHandler === void 0 ? function () {
          return null;
        } : _ref6$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.setAPILoading(QITAF_REDEEM);
              _context4.prev = 1;
              _context4.next = 4;
              return CartClient.redeemQitaf(payload);
            case 4:
              response = _context4.sent;
              _this5.onSuccess(response, QITAF_REDEEM);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              _this5.onError(_context4.t0, errorHandler, QITAF_REDEEM);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "redeemMokafaa", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function redeemMokafaa(_ref7) {
      var _this6 = this;
      var payload = _ref7.payload,
        _ref7$errorHandler = _ref7.errorHandler,
        errorHandler = _ref7$errorHandler === void 0 ? function () {
          return null;
        } : _ref7$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.setAPILoading(MOKAFAA_REDEEM);
              _context5.prev = 1;
              _context5.next = 4;
              return CartClient.redeemMokafaa(payload);
            case 4:
              response = _context5.sent;
              _this6.onSuccess(response, MOKAFAA_REDEEM);
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              _this6.onError(_context5.t0, errorHandler, MOKAFAA_REDEEM);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "redeemWallet", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function redeemWallet(_ref8) {
      var _this7 = this;
      var payload = _ref8.payload,
        _ref8$errorHandler = _ref8.errorHandler,
        errorHandler = _ref8$errorHandler === void 0 ? function () {
          return null;
        } : _ref8$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.setAPILoading(WALLET_REDEEM);
              _context6.prev = 1;
              _context6.next = 4;
              return CartClient.redeemWallet(payload);
            case 4:
              response = _context6.sent;
              _this7.onSuccess(response, WALLET_REDEEM);
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              _this7.onError(_context6.t0, errorHandler, WALLET_REDEEM);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 8]]);
      })();
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetApiState", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "resetApiState"), _class.prototype)), _class));
export { CartStore as default };